module.exports = __webpack_public_path__ + "2fe3399f3dc89d2289428f0d378698ef.pdf";